"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Translate_1 = require("../Translate");
require("./Header.scss");
class Header extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "content", id: "textbox" },
            React.createElement("h1", null,
                React.createElement(Translate_1.Translate, { i18n: this.props.title })),
            this.props.text ? React.createElement("p", null,
                React.createElement(Translate_1.Translate, { i18n: this.props.text })) : null));
    }
}
exports.Header = Header;
